import Button from "components/shared/Button";
import Frame from "components/shared/Frame";
import React, { MouseEventHandler, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import ReactModal from "react-modal";
import axios from "axios";
import { parse } from "papaparse";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import { useAuth } from "components/shared/AuthProvider";
import jwtDecode from "jwt-decode";
import { isAmericaUAdmin } from "utils/UIProvider";
import ComboFilter from "components/ComboFilter";
import { api } from "../../../constants";
import SmallBtn from "components/shared/SmallBtn";
import UploadResults from "components/shared/ShowUploadProgressAndResult";
import ErrorFile from "components/ErrorFile";

ReactModal.setAppElement("#root");

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

const Options = ({
  onEmailMethod,
}: {
  onEmailMethod: MouseEventHandler<HTMLButtonElement>;
}) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [user, setUser] = useState(null);
  const [search, URLSearchParamsInit] = useSearchParams();

  const token = search.get("token");
  const error = search.get("error");

  useEffect(() => {
    const fetchUser = async () => {
      if (token) {
        const formData = new FormData();
        formData.append("token", token);

        const results = await axios.post<{
          state: number;
          error: string;
          token?: string;
        }>("/woogi/0.1/actor/cgi.php?cmd=ModHandle.getUserInfo", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const data = results.data as any;

        setUser(data.data);
      }
    };

    fetchUser();

    return () => {};
  }, [token]);

  function openModal() {
    URLSearchParamsInit("");

    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const handleClassLink = () => {
    closeModal();

    if (import.meta.env.CLASS_LINK) {
      window.location.href =
        import.meta.env.CLASS_LINK + `?redirect_uri=${window.location.href}`;
    } else {
      window.alert("Your app is not configured. Class Link is missing.");
    }
  };

  return (
    <div>
      {user && (
        <div className="flex-column d-flex">
          <h2>Congratulations!</h2>
          <div className="py-3">
            <h5>
              Your students can now play Heroic Game Day using their ClassLink
              login.
            </h5>

            <div className="d-flex flex-row justify-content-around mb-4 mt-4">
              <SmallBtn
                title="Play Now"
                onClick={() => window.open("http://heroesleague.us/", "_blank")}
              />{" "}
            </div>
          </div>
        </div>
      )}

      {error && (
        <div className="flex-column d-flex">
          <h2 style={{ color: "red" }}>Error!</h2>
          <div className="py-3">
            <h5>{error}</h5>
          </div>
          <div className="d-flex flex-row justify-content-around mb-4 mt-3">
            <SmallBtn title="Try again!" onClick={() => openModal()} />
            <SmallBtn title="I need help!" onClick={() => openModal()} />
          </div>
        </div>
      )}

      {!user && !error && (
        <div>
          <h2>What do your students use to login?</h2>
          <div className="d-flex flex-row justify-content-evenly my-5">
            <SmallBtn title="ClassLink" onClick={() => openModal()} />
            <SmallBtn title="Email" onClick={onEmailMethod} />
            <ReactModal
              isOpen={modalIsOpen}
              onRequestClose={closeModal}
              style={customStyles}
              contentLabel="Help"
            >
              <p>
                You will need to assign the Heroic Game Day app to your
                ClassLink Management Console.
              </p>
              <p>
                Apps can be assigned to users by Profile, Group, or User from
                your custom apps list (or from the global{" "}
                <a
                  href="https://classlink.zendesk.com/hc/en-us/articles/115005631828"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  App Library
                </a>{" "}
                ) in your ClassLink Management Console (CMC) within Add and
                Assign Apps. Additionally, when leveraging Roster Server,
                applications can also be assigned by Orgs, Courses, or Classes.
              </p>
              <p>
                Click{" "}
                <a
                  href="https://classlinkcommunity.force.com/ClassLinkCustomerService/s/article/Assigning-Applications"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  here
                </a>{" "}
                to watch a video on How to assign applications in ClassLink
                Management Console (Recommended).
              </p>
              <p>
                <b>Step 1:</b> Open the CMC.
              </p>
              <p>
                <b>Step 2:</b> Click Applications, then select Add & Assign
                Apps.
              </p>
              <p>
                <b>Step 3:</b> Scroll or use the search feature to locate the
                application, Heroic.
              </p>
              <p>
                <b>Step 4:</b> Click the Assign button.
              </p>
              <p>
                <b>Step 5:</b> Click the Add button for the desired Profile(s),
                Group(s), or User(s) - pointing to the connected Active
                Directory (AD), Azure, or Google domain.
              </p>
              <p>
                <b>Step 6:</b> Alternatively, assignment of applications can be
                made by Orgs, Courses, or Classes, or by{" "}
                <a
                  href="https://classlinkcommunity.force.com/ClassLinkCustomerService/s/article/Assigning-Applications"
                  target={"_blank"}
                  rel="noreferrer"
                >
                  Roster Server permissions
                </a>
                - pointing to Roster Server's SIS data, if available.
              </p>
              <p>
                <b>Step 7:</b> Close.
              </p>

              <div className="d-flex flex-row justify-content-around">
                <Button value="Done" onClick={() => handleClassLink()} />
                <Button
                  value="I need Help!"
                  onClick={() =>
                    window.open("https://americau.com/sign-up/", "_blank")
                  }
                />
              </div>
            </ReactModal>
          </div>
        </div>
      )}
    </div>
  );
};

const UploadStudentForm = ({ onChange, isFile }: any) => {
  return (
    <div>
      <CSVLink
        style={{ fontSize: 25, fontWeight: "bold" }}
        data={[
          {
            "First Name": "Abc",
            "Last Name": "Xyz",
            "Grade Level": "1",
            "Student Email": "user1@test.com",
            Username: "user_1",
            Password: "some_password1",
          },
          {
            "First Name": "Abc",
            "Last Name": "Xyz",
            "Grade Level": "2",
            "Student Email": "user2@test.com",
            Username: "user_2",
            Password: "some_password2",
          },
          {
            "First Name": "Abc",
            "Last Name": "Xyz",
            "Grade Level": "1",
            "Student Email": "user3@test.com",
            Username: "user_3",
            Password: "some_password3",
          },
          {
            "First Name": "Abc",
            "Last Name": "Xyz",
            "Grade Level": "5",
            "Student Email": "user4@test.com",
            Username: "user_4",
            Password: "some_password4",
          },
          {
            "First Name": "Abc",
            "Last Name": "Xyz",
            "Grade Level": "3",
            "Student Email": "user5@test.com",
            Username: "user_4",
            Password: "some_password4",
          },
        ]}
      >
        Sample Template
      </CSVLink>
      <div className={isFile ? "file-drop-area file-exist" : "file-drop-area"}>
        {!isFile && (
          <>
            <span className="choose-file-button">Choose files</span>
            <span className="file-message">or drag and drop files here</span>
          </>
        )}

        {isFile && <h3>{isFile.name}</h3>}

        <input
          onChange={onChange}
          className="file-input"
          type="file"
          accept=".csv"
        />
      </div>
      <div style={{ marginBottom: 30 }}>
        <h4>We will send a file back including usernames and passwords.</h4>
      </div>
    </div>
  );
};

const SchoolRegistrationProcess = ({
  school,
  showSearchSchool,
}: {
  school: any;
  showSearchSchool: Function;
}) => {
  const [currentPath, setCurrentPath] = useState("options");
  const [file, setFile] = useState<File | null>(null);
  const [fileResponse, setFileResponse] = useState("");

  const { token } = useAuth();

  const handleFileUpload = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const isFile = ev.currentTarget.files?.item(0);
    if (isFile) setFile(isFile);
  };

  const backHanlder = () => {
    if (currentPath === "options") return showSearchSchool();
    if (currentPath === "uploadFile") return setCurrentPath("options");
    if (currentPath === "error") return setCurrentPath("uploadFile");
    if (currentPath === "uploading") return setCurrentPath("uploadFile");
  };

  const uploadFile = async () => {
    if (file) {
      const id = toast.loading(
        "Please wait... Working on account registration."
      );

      parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: async function (results: any) {
          if (results.errors.lenght > 0) {
            setCurrentPath("error");

            return toast.update(id, {
              render: "There is problem validating the CSV. Please contact us.",
              type: "error",
              isLoading: false,
            });
          }

          const data: any[] = results.data;

          setCurrentPath("uploading");

          if (!token) return;

          const access_token: any = (jwtDecode(token) as any).user.access_token;

          try {
            const resp = await axios.post(api, {
              cmd: "ModHandle.uploadFileToSignUp",
              data,
              school_id: school.ID,
              token: access_token,
              school_name: school.Building_Name,
            });

            if (resp.data.status == 0) {
              toast.update(id, {
                render:
                  "Success! please wait until we finish creating accounts.",
                type: "success",
                isLoading: false,
              });
            } else {
              toast.update(id, {
                render: resp.data.msg,
                type: "error",
                isLoading: false,
              });
            }

            setFileResponse(resp.data);
          } catch (error: any) {
            toast.update(id, {
              render: error.message,
              type: "error",
              isLoading: false,
            });

            console.log(error);
            window.alert(error.message);
          }

          setTimeout(() => {
            toast.dismiss(id);
          }, 1500);
        },
      });
    }
  };

  return (
    <Frame
      title={
        currentPath === "uploadFile"
          ? "Upload Student File"
          : "Students Account Creation"
      }
      onBackButtonClick={backHanlder}
    >
      {currentPath === "options" && (
        <Options onEmailMethod={() => setCurrentPath("uploadFile")} />
      )}

      {currentPath === "uploadFile" && (
        <div className="flex justify-center flex-col">
          <UploadStudentForm isFile={file} onChange={handleFileUpload} />
          <div className="flex items-center justify-center">
            <Button value="Send" btnType="green" onClick={() => uploadFile()} />
          </div>
        </div>
      )}

      {currentPath === "uploading" && <UploadResults results={fileResponse} />}

      {currentPath === "error" && <ErrorFile />}
    </Frame>
  );
};

const SchoolSearchLocal = ({ school, onSelectSchool, onNext }: any) => {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const results = await axios.get(api + "/find-school");

        if (results.status === 200) {
          setSchools(results.data.schools);
        }
      } catch (error) {
        window.alert((error as any).message);
      }
    })();
  }, []);

  return (
    <Frame
      showBackBtn={false}
      title="Search School"
      onBackButtonClick={() => {}}
    >
      <div className="mb-3">
        <ComboFilter
          placeholder="Select school"
          label={"Please wait until schools load successfully"}
          value={school}
          onChange={(school: any) => onSelectSchool(school.value)}
          items={schools.map((s: any) => ({
            value: s,
            label: s.Building_Name + " - " + s.District_Name + " - " + s.County,
          }))}
          isClearable={false}
        />
      </div>

      {schools.length > 0 && <Button value="Next" onClick={onNext} />}
    </Frame>
  );
};

// main component
export const SignUpProcess = () => {
  const [path, setPath] = useState("localSearch");
  const { token } = useAuth();
  const [school, setSchool] = useState<any>();

  if (!school)
    return <SchoolSearchLocal schoolId={school} onSelectSchool={setSchool} />;

  return (
    <SchoolRegistrationProcess
      school={school}
      showSearchSchool={() => setPath("localSearch")}
    />
  );
};
